import {useEffect, useState} from 'react';
import {useNavigate} from 'react-router-dom';
import {URL_ADMIN, URL_ADMIN_BRANCH, URL_BRANCH_CLOSING_REPORT_PERFORMANCE} from 'routes/AdminRoute';
import {BaseSection} from 'components/layouts';
import {Col, Divider, Input, Row, Select, Space} from 'antd';
import {AlertModal, BaseContainer, SearchDesc} from 'components/containers';
import {DataGrid, FillButton, OutlinedButton, RoundTag, ExcelButton, BaseDatePicker} from 'components/elements';
import {GridSetting} from 'pages/common';
import dayjs from 'dayjs';
import {getListAPI} from 'api/common';
import {fnSetColumn, utilSearchData} from 'utils/utils';
import {closeSubmitOptions} from 'data/options';
import {getLocalStorage} from 'hooks/useLocalStorage';
import {exportStyleExcelDownload} from 'utils/file';
import {postHqBranchClosingReport} from 'api/hq';

const HqBranchCloseReport = ({common}) => {
  const navigate = useNavigate();
  const menu = getLocalStorage('openMenuInfo');
  const [mon, setMon] = useState(dayjs());
  const year = new Date().getFullYear();
  const [colList, setColList] = useState({
    gridSettingList: [],
    gridList: []
  });
  const [gridSetting, setGridSetting] = useState([]);
  const [columns, setColumns] = useState([]);
  const [data, setData] = useState([]);
  const [stats, setStats] = useState([]);
  const [param, setParam] = useState({
    close_date: dayjs().format('YYYY-MM'),
    submit_status: '-1',
    branch_name: ''
  });

  const [alertModal, setAlertModal] = useState({
    open: false,
    message: ''
  });
  const fnCloseAlertModal = () => {
    setAlertModal({...alertModal, open: false, message: ''});
  };

  const fnExcelDownload = () => {
    const processData = data?.map((item) => {
      let submit = '';
      if (item?.SUBMIT_STATUS === '-1') {
        submit = '전체';
      } else if (item?.SUBMIT_STATUS === '1') {
        submit = '제출';
      } else if (item?.SUBMIT_STATUS === '2') {
        submit = '미제출';
      }

      let approval = '';
      if (item?.APPROVAL_STATUS === '1') {
        approval = '승인';
      } else {
        approval = '반려';
      }
      const obj = {}
      colList?.gridList.forEach(it => {
        if ('SUBMIT_STATUS' === it.dataIndex) {
          obj['SUBMIT_STATUS'] = submit
        } else if ('APPROVAL_STATUS' === it.dataIndex) {
          obj['APPROVAL_STATUS'] = approval
        } else {
          obj[it.dataIndex] = item[it.dataIndex]
        }
      });
      return obj
    });

    const headerList = colList?.gridList.map(it => it.title)
    exportStyleExcelDownload(headerList, processData, menu?.depth?.[1]);
  };

  const getList = async () => {
    try {
      // 공통 서치바 데이터 체크 및 데이터 리턴
      const result = utilSearchData(param);

      if (typeof result === 'string') {
        setAlertModal({...alertModal, open: true, message: result});
      } else {
        const {data} = await getListAPI(result);
        setColList({
          ...colList,
          gridSettingList: data?.COLUMS_LIST,
          gridList: fnSetColumn(data?.COLUMS_LIST, column)
        });
        setStats(data?.STATICS_LIST);
        setColumns(fnSetColumn(data?.COLUMS_LIST, column));
        setGridSetting(data?.COLUMS_LIST);
        setData(data?.DATA_LIST);
      }
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    getList();
  }, []);

  const approvalStatus = async (status, reportIdx) => {
    try {
      const res = await postHqBranchClosingReport({report_idx: reportIdx, approval_status: status});

      if (res.status === 200) {
        switch (status) {
          case 1:
            window.alert('승인 되었습니다.');
            break;
          case 2:
            window.alert('반려 되었습니다.');
            break;
          default:
            break;
        }
      }

      getList();
    } catch (e) {
      console.log(e);
    }
  };

  const column = [
    {
      title: '번호',
      align: 'center',
      dataIndex: 'IDX'
    },
    {
      title: '지사명',
      align: 'center',
      dataIndex: 'BRANCH_NAME'
    },
    {
      title: '지사아이디',
      align: 'center',
      dataIndex: 'BRANCH_ID'
    },
    {
      title: '지사장명',
      align: 'center',
      dataIndex: 'BRANCH_LEADER_NAME'
    },
    {
      title: '휴대폰번호',
      align: 'center',
      dataIndex: 'CELL_PHONE'
    },
    {
      title: '제출현황',
      align: 'center',
      dataIndex: 'SUBMIT_STATUS',
      render: (value, record, index) => {
        return value === 0 ? <span className="text-red">미제출</span> : <span>제출</span>;
      }
    },
    {
      title: '건의사항',
      align: 'center',
      dataIndex: 'PROPOSE_ISSUE',
      width: '30rem'
    },
    {
      title: '상세보기',
      align: 'center',
      dataIndex: 'col8',
      render: (value, record) => {
        const month = mon?.$M + 1
        const monUrl = URL_ADMIN + URL_ADMIN_BRANCH + URL_BRANCH_CLOSING_REPORT_PERFORMANCE + '?mon=' + (mon?.$M + 1);
        return <OutlinedButton label="상세" onClick={() => navigate(monUrl, { state: { branchIdx: record.BRANCH_IDX, year: year, month: month, reportIdx: record.REPORT_IDX } })} />;
      }
    },
    {
      title: '승인상태',
      align: 'center',
      dataIndex: 'APPROVAL_STATUS',
      render: (value, record) => {
        console.log(value, record)
        let label, color;
        // value에 따른 라벨과 색상 설정
        switch (value) {
          case 1:
            label = '승인';
            color = 'purple';
            break;
          case 2:
            label = '반려';
            color = 'orange';
            break;
          default:
            label = '';
            color = '';
        }
        // const idx = record.IDX;
        const reportIdx = record.REPORT_IDX;
        return (
          <Space>
            {value === 0 ? (
              <>
                <FillButton
                  label="승인"
                  backgroundColor={'#D0A9F5'}
                  onClick={() => {
                    approvalStatus(1, reportIdx);
                  }}
                />
                <FillButton
                  label="반려"
                  backgroundColor={'#F5F6CE'}
                  color="black"
                  onClick={() => {
                    approvalStatus(2, reportIdx);
                  }}
                />
              </>
            ) : (
              <RoundTag label={label} color={color}/>
            )}
          </Space>
        );
      }
    }
  ];

  const items = [
    {
      key: 1,
      label: '검색일',
      children: 
        <BaseDatePicker
          type={'month'}
          format={'YYYY-MM'}
          allowClear={false}
          value={param?.close_date}
          onChange={dateString => setParam({ ...param, close_date: dateString })}
        />,
      span: 1
    },
    {
      key: 2,
      label: '제출현황',
      children: (
        <>
          <Select placeholder={'전체'} value={param?.submit_status} style={{width: '12rem'}} options={closeSubmitOptions}
                  onSelect={(e) => setParam({...param, submit_status: e})}/>
        </>
      ),
      span: 1
    },
    {
      key: 3,
      label: '지사명',
      children: (
        <Space>
          <Input
            style={{width: '16rem'}}
            value={param?.branch_name}
            onChange={(e) => {
              setParam({...param, branch_name: e.target.value});
            }}
            onPressEnter={getList}
          />
        </Space>
      ),
      span: 1
    },
    {
      key: 4,
      label: <FillButton label="검색하기" width="100px" backgroundColor="var(--color-gray03)" onClick={getList}/>,
      children: <></>,
      span: 1
    }
  ];

  //표설정 변경시 테이블 항목 업데이트
  const fnUpdateGridSetting = (v) => {
    setColList({
      ...colList,
      gridList: fnSetColumn(v, column)
    });
    setColumns(fnSetColumn(v, column));
    setGridSetting(v);
  };

  return (
    <BaseSection>
      <SearchDesc items={items} column={items?.length} labelStyle={{width: '50px'}} inline/>
      <BaseContainer>
        <Row>
          <Col span={24}>
            <Space>
              <GridSetting colList={gridSetting} fnUpdateCol={fnUpdateGridSetting}/>
              <ExcelButton
                // label={'엑셀 다운로드(검색)'} //뷰네임 미입력시 기본값
                // isCheckComp={true} //체크박스 컴포넌트 여부 미입력시 X
                headerList={columns} //필수 헤더리스트 표 설정과 동일한 변수여야함
                gridList={data} //필수 실시간 그리드 데이터
                filterList={['col8']} //뺄 칼럼 목록 dataIndex 미입력시 dataIndex 키 없는것만 뺌
                renderList={[
                  {
                    dataIndex: 'APPROVAL_STATUS',
                    render: (item) => {
                      if (item === 1) {
                        return '승인'
                      } else if (item === 2) {
                        return '반려'
                      } else {
                        return ''
                      }
                    }
                  },
                ]} //코드 or 다른이름으로 바꿔서 다운할 목록
                // checkRows={} //isCheckComp true 일시 checkRows 데이터 미입력시 체크작동안함
                // checkKey={} //isCheckComp true 일시 check 한 데이터 dataIndex 키 네임 미입력시 체크작동안함
                // fileName={} //파일네임 미입력시 해당 메뉴이름
              />
            </Space>
            <Divider className="divider-small"/>
            <DataGrid rowKey={(record) => `${record.IDX}`} columns={columns} data={data} pagination/>
          </Col>
        </Row>
      </BaseContainer>
      {/* alert 모달 */}
      <AlertModal open={alertModal?.open} onCancel={fnCloseAlertModal}>
        {alertModal?.message}
      </AlertModal>
    </BaseSection>
  );
};

export default HqBranchCloseReport;
